import { inject, Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { SessionService } from '../_services'

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  sessionService: SessionService = inject(SessionService)
  router: Router = inject(Router)

  constructor() {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((err) => {
      if (err.status === 401) {
        // Aktuelle URL merken und nach Logout als returnUrl mitgeben
        const currentUrl = this.router.url
        this.sessionService.logoutWithReturnUrl(currentUrl)
      }

      // Fehler als lesbaren String weiterreichen (bestehende Konsumenten
      // erwarten einen String). Rails-Validierungsfehler kommen als
      // { attribut: [meldungen] } OHNE message-Feld — deren Meldungen hier
      // einsammeln, sonst ginge die eigentliche Fehlerursache verloren und
      // überall käme nur der nichtssagende statusText an.
      const data = err.error
      const validationMessages =
        data && typeof data === 'object'
          ? Object.values(data)
              .filter((v): v is string[] => Array.isArray(v))
              .flat()
              .filter((m) => typeof m === 'string')
          : []
      const error = data?.message || (validationMessages.length ? validationMessages.join(' — ') : null) || err.statusText
      return throwError(error)
    }))
  }
}
